module.exports = __webpack_public_path__ + "img/hero.4da4e27a.svg";